import { Box, FormControl, Stack, TextField, Typography } from "@mui/material";
import React from "react";

const InputCryptoAddress = ({ setAddress }) => {
	const addressChange = (e) => {
		e.preventDefault();
		setAddress(e.target.value.toString().trim());
	};
	return (
		<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
			<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
				<Typography component="h2" variant="subtitle2" gutterBottom>Address</Typography>
				<Stack spacing={2} direction={"row"}>
					<TextField fullWidth label={"Enter your address"} variant="outlined" size="medium" onChange={addressChange} color="black" />
				</Stack>
			</Box>
		</FormControl>
	);
};

export default InputCryptoAddress;
